export enum CalendarioMutationTypes {
  SET_CONTEXTO = 'SET_CONTEXTO',
}
